<template>
  <v-dialog
    content-class="contact-stay-control-quiz-dialog"
    :value="true"
    :transition="false"
    @click:outside="saveCustomQuizDialog"
    @keydown.esc="saveCustomQuizDialog"
  >
    <v-card>
      <v-container class="px-8 pt-6 pb-4 contact-stay-control-quiz-dialog-container">
        <v-card-text class="pa-0 contact-stay-control-quiz-dialog-title">
          {{ $t('common.contact') }}
        </v-card-text>
          <v-btn
            icon
            width="fit-content"
            height="fit-content"
            class="contact-stay-control-quiz-dialog-close-button"
            @click="closeDialog"
          >
            <close-icon class="stay-control-quiz-dialog-close-icon" />
          </v-btn>
      </v-container>

      <div v-if="!showSelectionMessengerList">
        <div class="px-8 contact-stay-control-quiz-messenger-input-title">
         {{ getSelectedMessenger }}
        </div>
        <div>
          <v-text-field
            v-model="currentSelectedMessengerValue"
            rounded
            dense
            outlined
            hide-details
            class="contact-stay-control-quiz-messenger px-8"
            @keydown.enter="saveCustomQuizDialog"
          />
        </div>
        <div
          class="change-other-messenger"
          @click="toggleMessengerOptions"
        >
          {{ $t('common.otherMessenger') }}
        </div>
        <v-card-actions class="px-6 pt-6 pb-6 d-flex">
          <v-btn
            class="custom-messenger-stay-control-quiz-dialog-contact-quiz-btn px-3 py-0"
            color="button-primary-background-default"
            @click="saveCustomQuizDialog"
          >
            <span class="custom-messenger-stay-control-quiz-dialog-contact-quiz-btn-txt">
              {{ $t('common.save') }}
            </span>
          </v-btn>
        </v-card-actions>
      </div>

      <!-- БЛОК ВЫБОРА МЕССЕНДЖЕРОВ -->
      <messenger-selection
        v-if="showSelectionMessengerList"
        @selectMessenger="selectMessenger"
        @cancelMessengerSelectionAction="toggleMessengerOptions"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import CloseIcon from '@/assets/svgIcons/closeIcon.svg?inline'
import MessengerSelection from '@/components/dialogs/MessengerSelection.vue'
import { messengerMixin } from '@/mixins/quizMessengers'
import { TELEGRAM_MESSENGER } from '@/constants/quiz'

export default {
  name: 'ChangeMessengerContact',
  components: {
    MessengerSelection,
    CloseIcon
  },
  mixins: [messengerMixin],
  props: {
    selectedMessengerValue: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      showSelectionMessengerList: false,
      currentSelectedMessenger: '',
      currentSelectedMessengerValue:  this.selectedMessengerValue,
      sendMessengerName: ''
    }
  },
  computed: {
    getSelectedMessenger () {
      return this.currentSelectedMessenger || TELEGRAM_MESSENGER
    }
  },
  methods: {
    saveCustomQuizDialog () {
      this.sendMessengerName = this.getMessengerName(this.getSelectedMessenger);
      this.$emit('saveDialogChangeMessenger', this.sendMessengerName, this.currentSelectedMessengerValue,);
    },

    closeDialog () {
      this.$emit('closeDialogChangeMessenger')
    },

    toggleMessengerOptions () {
      this.showSelectionMessengerList = !this.showSelectionMessengerList
    },

    selectMessenger (messengerName) {
      this.currentSelectedMessenger = messengerName
      this.currentSelectedMessengerValue = ''
      this.toggleMessengerOptions()
    }
  }
}
</script>

<style lang="scss">
.crying-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact-stay-control-quiz-messenger-input-title {
  margin-bottom: 6px;
  color: var(--v-text-secondary-base);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.contact-stay-control-quiz-dialog {
  border-radius: 16px;
  width: 500px;
}

.custom-messenger-stay-control-quiz-dialog-contact-quiz-btn-txt {
  color: var(--v-button-primary-foreground-default-base);
  text-transform: uppercase;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
}

.contact-stay-control-quiz-dialog-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.custom-stay-control-quiz-dialog-body-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--v-text-primary-base);
  font-family: Roboto,serif;
}

.change-other-messenger {
  color: var(--v-link-primary-text-default-base);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  margin-top: 12px;
  border-bottom: 1px solid var(--v-link-primary-border-default-base);
  width: fit-content;
  margin-left: 32px;
}

.custom-messenger-stay-control-quiz-dialog-contact-quiz-btn {
  gap: 8px;
  border-radius: 50px;
  display: flex;
  height: 36px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.12), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.20);
}

.contact-stay-control-quiz-dialog-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--v-text-primary-base);
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: normal;
  font-family: Roboto,serif;
}

.contact-stay-control-quiz-dialog-close-button {
  fill: var(--v-old-icon-button-outline-secondary-foreground-default-base);
  right: 16px;
  padding: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 16px;
}

.stay-control-quiz-dialog-close-icon {
  width: 24px;
  height: 24px;
  color: var(--v-button-secondary-gray-foreground-default-base);
}

.v-sheet .v-card__actions .quiz-exit-btn {
  height: 48px;
  padding: 16px 32px;
  max-width: 140px;
  min-width: unset!important;
  background-color: transparent;
}
</style>
